
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerClass()
    export class CalendarBaseGrid extends SiteEntityGrid<CalendarBaseRow, any> {
        protected getColumnsKey() { return 'Scheduling.CalendarBase'; }
        protected getDialogType() { return CalendarBaseDialog; }
        protected getIdProperty() { return CalendarBaseRow.idProperty; }
        protected getInsertPermission() { return CalendarBaseRow.insertPermission; }
        protected getLocalTextPrefix() { return CalendarBaseRow.localTextPrefix; }
        protected getService() { return CalendarBaseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}